import Address from '../../../AddressBuilder.js'

const _path = {
  XZQHXXB: Address.business('bzdzXzqhxxb', Address.CONFIG.VERSION.version_1),
}

export default {

  tree(_parameter) { // 行政区划tree
    return sHttp.postJson(_path.XZQHXXB + 'tree', _parameter)
  },
  add(_parameter) { // 行政区划新增
    return sHttp.postJson(_path.XZQHXXB + 'add', _parameter)
  },
  update(_parameter) { // 行政区划新增
    return sHttp.postJson(_path.XZQHXXB + 'update', _parameter)
  },
  delete(_parameter) { // 行政区划删除
    return sHttp.postJson(_path.XZQHXXB + 'delete', _parameter)
  },
}

